import { CSSProperties, useCallback, useEffect, useState } from 'react';

import cx from 'classnames';

import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { getPageAnchorId } from 'utils/itineraries/functions/utils';

import { useLandingV2Context } from '../../context';
import { getPrefix } from '../../utils';
import { usePageContext } from '../context';
import { EPageLayout } from '../types';
import s from './index.module.css';

export function useRightSide() {
  const { data, config: pageConfig, index, virtualized } = usePageContext();
  const { isManualScrollRef, headerRef, contentRef, config, setActivePageId } = useLandingV2Context();
  const [topMargin, setTopMargin] = useState(0);
  const { isTabletOrMobile } = useMediaBreakpoints();
  const className = cx(
    s.right,
    getPrefix('right'),
    `custom-page-type-${data.type}`,
    `custom-page-role-${data.role}`,
    pageConfig.layout === EPageLayout.FullWidth && s.verticalOrientation,
  );

  const handleIntersection = useCallback(
    (event: any) => {
      const activePageIdSettingCondition = isTabletOrMobile
        ? event.isIntersecting
        : event.isIntersecting && isManualScrollRef.current;

      if (activePageIdSettingCondition) {
        setActivePageId({ pageId: data.id, notifyExternalEnv: true });
      }
    },
    [data.id, isManualScrollRef, setActivePageId, isTabletOrMobile],
  );

  useEffect(() => {
    if (contentRef.current) {
      if (!headerRef.current) {
        setTopMargin(0);

        return;
      }

      // +10 to be sure header greater or equal
      const headerWidth = headerRef.current.getBoundingClientRect()?.width + 10;
      const contentWidth = contentRef.current.getBoundingClientRect()?.width;

      if (headerWidth >= contentWidth || isTabletOrMobile) {
        // setting top margin at 0 is needed for applying layout again
        // if header layout was changed in custom css
        setTopMargin(0);

        return;
      }

      setTopMargin(headerRef.current?.getBoundingClientRect()?.height);
    }
    // keep 'config' dependency to be sure landing header will be re-rendered
    // if settings for template configuration were changed
  }, [headerRef, config, contentRef, isTabletOrMobile]);

  return {
    handleIntersection,
    rightSideProps: {
      id: getPageAnchorId(data.id),
      'data-index': index,
      style: {
        '--topMargin': topMargin + 'px',
        ...(virtualized && !virtualized.rendered ? { height: virtualized.height + 'px' } : {}),
      } as CSSProperties,
    },
    className,
  };
}

export const getModalTitleText = (type: string) => {
  switch (type) {
    case 'media':
      return 'Add Photos';
    case 'document':
      return 'Add PDF';
    default:
      return 'Add file';
  }
};
